import React from "react"
import { Link, graphql, StaticQuery } from "gatsby"
import Img from "gatsby-image"
import { Carousel} from "react-bootstrap"
import "../Styles/index.scss"

const LeftImageSlider = () => {
  return (
    <div className="slider-left">
      <StaticQuery
        query={leftsliderquery}
        render={data => {
          return (
            <Carousel className="slider-left-carousel">
              {data.allMarkdownRemark.edges.map(({ node }) => (
                <Carousel.Item>
                  <Link to={node.fields.slug}>
                    <Img
                      className="slider-left-img"
                      fluid={node.frontmatter.image.childImageSharp.fluid}
                      alt="first slide"
                    />
                    <Carousel.Caption>
                      <div className="slider-left-caption">
                         <h4>{node.frontmatter.title} </h4> <p>{node.frontmatter.artist}</p>
                      </div>
                    </Carousel.Caption>
                  </Link>
                </Carousel.Item>
              ))}
            </Carousel>
          )
        }}
      />
    </div>
  )
}

const leftsliderquery = graphql`
  query {
    
      allMarkdownRemark(sort: {fields: [frontmatter___date], order: DESC}, filter: {children: {}, frontmatter: {cat: {eq: "music"}}}) {
        edges {
          node {
            id
            frontmatter {
              title
              artist
              cat
              image {
                childImageSharp {
                  fluid(maxWidth: 500) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
            excerpt(truncate: true)
            fields {
              slug
            }
          }
        }
      }
    }
    
`

export default LeftImageSlider
